/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next'

import { IColumn } from 'types'

export const useTableModel = () => {
  const { t } = useTranslation()

  const columns: IColumn[] = [
    {
      title: `${t('common.subject')}`,
      field: 'subject',
      width: '40%',
    },
    {
      title: `${t('dashboard.target')}`,
      field: 'target',
      width: '20%',
      align: 'center'
    },
    {
      title: `${t('dashboard.rest-of-term-avg')}`,
      field: 'avg',
      width: '40%',
      align: 'center'
    },
  ]

  return columns
}
